import { SPIDService } from './../../services/spid.service';
import { NotificationTypeEnum } from './../../models/notification-center/notification-parameter.model';
import { ShopService } from './../../services/shop.service';
import { PortaleFEService } from './../../services/portaleFE.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AuthService } from './../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserDTO } from './../../models/user.model';
import { AfterViewInit, Component, ElementRef,  Inject, OnDestroy, Renderer2, TemplateRef, ViewChild } from "@angular/core";
import { MenuService } from '../../services/menu.service';
import { CompanyListDTO, CompanyTypeEnum } from '../../models/company.model';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { GlobalService } from '../../services/global.service';
import { TranslateService } from '@ngx-translate/core';
import i18n_it from "../../../assets/i18n/i18n_it.json";
import i18n_en from "../../../assets/i18n/i18n_en.json";
import i18n_fr from "../../../assets/i18n/i18n_fr.json";
import { DOCUMENT } from '@angular/common';
import { FixTemplateService } from '../../services/fixtemplate.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { OldSystemSurveyDTO } from '../../models/survey.model';
import Swal from "sweetalert2";
import { NotificationDetailDTO } from '../../models/notification-center/notificationDetail.model';
import * as signalR from "@microsoft/signalr";
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification-center/notification.service';
import { environment } from '../../../environments/environment';
import { EventHandlerService } from '../../services/eventHandler.service';
import moment from 'moment';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import themes from "devextreme/ui/themes";

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})


export class DefaultLayoutComponent implements AfterViewInit, OnDestroy {
  //@HostBinding('class') className='light-theme';
  // get themeMode(){
  //  return this.currentThemes
  // }
  messageReceived: any;
  private subscriptionName: Subscription; //important to create a subscription

  public sidebarMinimized = false;
  //Gestisce lo stato della barra laterale tramite l'"hamburger"
  public sidebarHamburgerMinimized = false;
  public tooltipSidebarMinimized = "";
  // public navItems = new Array<INavData>();
  public currentUser: UserDTO;
  @ViewChild('select-company') select: NgSelectComponent;

  public manageableCompanies: Array<CompanyListDTO> = new Array<CompanyListDTO>();
  public currentCompany: CompanyListDTO = null;
  public showCompanies: boolean = false;

  avatarName: string;

  @ViewChild("surveyModal", { static: true }) surveyModal: TemplateRef<any>
  surveyModalRef: MatDialogRef<TemplateRef<any>>
  oldSystemSurvey: OldSystemSurveyDTO;

  public globalService = GlobalService;

  //#region modale policy
  dialogPolicyReadedRef: MatDialogRef<TemplateRef<any>>;
  @ViewChild("dialogPolicyReaded", { static: true }) dialogPolicyReaded: TemplateRef<any>
  policyReadedCheckbox1: boolean = false;
  policyReadedCheckbox2: boolean = false;
  //#endregion

  //#region modale Survey
  dialogSurveyDoneRef: MatDialogRef<TemplateRef<any>>;
  @ViewChild("dialogSurveyDone", { static: true }) dialogSurveyDone: TemplateRef<any>
  //#endregion

  
  nRemainingInvoicesInside: number =0 ;
  notificationCount: number = 0;
  notificationList: Array<NotificationDetailDTO> = new Array<NotificationDetailDTO>();
  notificationReadSubscription: Subscription;
  private hubConnection: signalR.HubConnection;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  // Dialog per la visualizzazione di una notifica
  dialogViewNotificationRef: MatDialogRef<TemplateRef<any>>;
  @ViewChild('dialogViewNotification', { static: false }) dialogViewNotification: TemplateRef<any>;
  selectedNotification: NotificationDetailDTO;

  notificationToShow: NotificationDetailDTO[];

  iFrameURLCheck: SafeResourceUrl;
  displayiFrame = false;
  companytypeenum = CompanyTypeEnum;
  dontShowNamirialPayAgain: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private translate: TranslateService,
    private authService: AuthService,
    private menuService: MenuService,
    @Inject(DOCUMENT) public document: Document,
    private renderer: Renderer2,
    private templateFixService: FixTemplateService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private eventHandlerService: EventHandlerService,
    private portaleFEService: PortaleFEService,
    private shopService: ShopService,
    private spidService: SPIDService,
    private overlayContainer: OverlayContainer,
    private Service: GlobalService,
    private elementRef: ElementRef,
    public sanitizer: DomSanitizer,

  ) {

  }
  ngOnInit() {
    
    this.subscribeToUpdate();
    this.initializeTranslations();

    this.reloadComponent();

    this.currentUser = this.authService.getCurrentUser();    
    this.initManageableCompanies();    
    
    this.checkMyNamirialLogin();

    //this.checkReleaseNote();

    
    this.checkPolicyReaded();
    
    this.applyDarkMode();
    

    //Se è presente l'utente autenticato allora avvia i servizi per la ricezione delle notifiche push
    // if (this.authService.getCurrentUser() != null && this.authService.getCurrentUser() != undefined) {
    //   this.initializeSocketNotificationConnection();
    // }
  }

  private subscribeToUpdate() {
    this.subscriptionName = this.Service.getUpdate().subscribe(message => {
      this.messageReceived = message;
      this.currentUser = this.authService.getCurrentUser();

      this.applyDarkMode();

      this.reloadComponent();
    });
  }

  private applyDarkMode() {
    const containerElement = this.overlayContainer.getContainerElement();
    const body = this.elementRef.nativeElement.ownerDocument.body;
    const isDarkMode = this.currentUser.IsDarkMode;
    this.globalService.isDarkMode = this.currentUser.IsDarkMode;

    if (isDarkMode) {
      containerElement.classList.remove('light-theme');
      containerElement.classList.add('dark-theme');
      body.style.backgroundColor = '#2c2c2c';
//      themes.current("material.lime.dark");
     themes.current("material.custom-scheme.dark");

    } else {
      containerElement.classList.remove('dark-theme');
      containerElement.classList.add('light-theme');
      body.style.backgroundColor = '#EBEBED';
//      themes.current("material.lime.light");
      themes.current("material.custom-scheme.light");

    }
  }



  ngAfterViewInit() {
    let elements = document.querySelectorAll('.navbar-toggler');
    if (elements && elements.length > 1) {
      elements[1].innerHTML = "<span title=\"" + this.translate.instant("GENERIC_LABEL.COLLAPSE") + "\" class=\"navbar-toggler-icon\"></span>"
      var self = this;
      elements[1].addEventListener("click", function () {
        self.sidebarHamburgerMinimized = !self.sidebarHamburgerMinimized;
        self.tooltipSidebarMinimized = self.sidebarHamburgerMinimized == false ? self.translate.instant("GENERIC_LABEL.COLLAPSE") : self.translate.instant("GENERIC_LABEL.EXPAND")
        elements[1].innerHTML = "<span title=\"" + self.tooltipSidebarMinimized + "\" class=\"navbar-toggler-icon\"></span>"
      }, true);
    }
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = this.currentUser.IsDarkMode ? '#2c2c2c' : '#EBEBED';

  }

  ngOnDestroy(): void {
    if (this.notificationReadSubscription)
      this.notificationReadSubscription.unsubscribe();
    if (this.subscriptionName)
      this.subscriptionName.unsubscribe();
  }

  //Restituisce le azienda gestibili dall'utente corrente
  initManageableCompanies() {
    this.resetRouteReuseStrategy();
    let routeDashboard: boolean = this.router.url.includes("dashboard");

    this.userService.getAllUserCompanies(true, routeDashboard)
      .then((res) => {
        //Ordino alfabeticamente per denominazione la res se c'è almeno un elemento
        this.manageableCompanies = res != null && res.length > 0 ? res.sort((a, b) => a.Denomination.localeCompare(b.Denomination)) : res;
        let companyIDToSearch: number = GlobalService.getCurrentCompany() != null ? GlobalService.getCurrentCompany().ID : this.authService.getCurrentUser() != null ? this.authService.getCurrentUser().FK_Company : null;
        this.currentCompany = this.manageableCompanies != null && this.manageableCompanies.find(c => c.ID == companyIDToSearch) != null ? this.manageableCompanies.find(c => c.ID == companyIDToSearch) : this.manageableCompanies != null && this.manageableCompanies.length >= 0 ? this.manageableCompanies[0] : null;


        //Resinerito per survery annuale versione 2.6.0.0 - Se la company NON è di tipo shop, faccio vedere la survey
        //if (this.currentCompany != null && this.currentCompany.FK_CommercialProductInUse != 5)
        //   this.checkSurveyReaded();
        
        this.licenseExpiredDialog();
        this.fromShopQueueDialog();             
        this.fromNamirialPayOnboardingDialog();   
        this.remainingInvoicesFinished();
        this.remainingInvoicesInsideFinished();
        
                
        // Serve per il display dei valori aggiornati
        
        // if (GlobalService.getCurrentCompany() == null || GlobalService.getCurrentCompany() != null && GlobalService.getCurrentCompany().ID != this.currentCompany.ID)                    
        //     GlobalService.setCurrentCompany(this.currentCompany);
        // else
        //     GlobalService.FillStaticCompanyObject(this.currentCompany);                              
        
        GlobalService.setCurrentCompany(this.currentCompany);
        GlobalService.FillStaticCompanyObject(this.currentCompany);           
        if (this.currentCompany != null) {
          GlobalService.LoadInfoNamirialPayLinkPackage(this.currentCompany.ID);                           
        }
                

        this.menuService.setMenu();

        GlobalService.LoadDashBoardInfoFromUserService();          

        if (this.authService.getGestioneUfficiFlag() == "1") {
          this.router.navigate(["/document/list-documents"]);
        }

        if (GlobalService.getCurrentCompany() != null && GlobalService.getCurrentCompany().CompanyType == CompanyTypeEnum.DESK && GlobalService.getCurrentCompany().AuthFE != true) {    
          this.openFEUrl();
        }

      })
      .catch((err) => {
        DialogService.Error(err.message);
      });
  }

  /**
   * Evento scatenato alla selezione dell'azienda gestita, si occupa di memorizzare i dati nel sessionStorage e di ricaricare tutto il componente in modo da
   * aggiornare tutti i dati
   */
  changeManagedCompany() {
    if (this.currentCompany) {
      GlobalService.setCurrentCompany(this.currentCompany);      
      this.reloadComponent();
      this.router.navigate(["/dashboard"]);
    }
  }

   

  /**
   * Inizializza il menù a tendina per la selezione delle aziende gestibili
   */
  reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.router.url]);
  }

  /**
   * Reimposta la strategia per il reload delle rotte al valore di default.
   * Questo metodo viene richiamato ogni volta che si inizializza il componente, cioè in due momenti: quando viene avviata l'app dopo la login e quando si
   * cambia la company selezionata (in quest'ultimo viene forzato il reload della rotta corrente per potere aggiornare i dati).
   */
  resetRouteReuseStrategy() {
    this.router.routeReuseStrategy.shouldReuseRoute = (future, curr) => { return future.routeConfig === curr.routeConfig };
    this.router.onSameUrlNavigation = 'ignore';
  }

  switchCompanyToDefault() {
    this.currentCompany = this.manageableCompanies.find(company => company.ID == this.currentUser.FK_Company);
    if (this.currentCompany) {
      GlobalService.setCurrentCompany(this.currentCompany);
      this.reloadComponent();
    }
    this.router.navigate(["/dashboard"]);
  }

  toggleMinimize(e) {
    var self = this;
    this.sidebarMinimized = e;
    setTimeout(function () {
      self.templateFixService.fixedHeader(window, self.document, self.renderer);
    }, 600);
  }

  /**
   * Logout
   */
  logout() {
    this.authService.logout();
  }

  /**
   * Apre la sezione profilo utente
   */
  viewProfile() {
    this.router.navigate(['/profile'], { relativeTo: this.activatedRoute });
  }

  viewCompany() {
    this.router.navigate(['/core/company'], { relativeTo: this.activatedRoute });
  }

  viewProducts() {
    this.router.navigate(['/core/company-products'], { relativeTo: this.activatedRoute });
  }

  help() {
    if (this.router.url.split('?')[0] != "/help") {
      this.router.navigate(['/help'], { queryParams: { route: this.router.routerState.snapshot.url } });
    }
  }

  /**
   * Vengono inizializzate le translations, se non disponibili nel LOCALSTORAGE vengono definite di default a IT
   */
  initializeTranslations() {
    if (GlobalService.getSelectedLanguage() == "it") {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_it, true);
    } else if (GlobalService.getSelectedLanguage() == "fr") {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_fr, true);
    } else {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_en, true);
    }

    this.translate.use(GlobalService.getSelectedLanguage());
  }

  /**
   * Esco dalla gestione dell'azienda
   */
  exitManageCompany() {
    GlobalService.globalManageCompany(null);    
    this.reloadComponent();
  }

  //Recupero dinamicamente dall'api l'ambiente dove mi trovo facendomi restituire l'URL corretto (definito nelle variabili d'ambiente)
  async goToOldSystem() {
    let oldSystemUrl = await this.userService.getOldSystemURL();
    let shareXLSToken = this.authService.getCurrentShareXLSToken();

    if (shareXLSToken == null)
      window.location.href = oldSystemUrl;
    else
      window.location.href = oldSystemUrl + "?newFattureToken=" + this.authService.getCurrentShareXLSToken();
  }

  /**
   * Apre la modale per mostrare il
   */
  openSurveyModal() {
    this.oldSystemSurvey = new OldSystemSurveyDTO();
    this.surveyModalRef = this.dialog.open(this.surveyModal,
      {
        minHeight: "20%",
        minWidth: "40%",
        maxWidth: "60%",
        hasBackdrop: true,
        autoFocus: false,
      });
  }

  closeSurveyModal() {
    this.oldSystemSurvey = new OldSystemSurveyDTO();
    this.surveyModalRef.close();
  }

  confirmSurveyModal() {
    this.oldSystemSurvey.Name = this.currentCompany.Denomination != "" ? this.currentCompany.Denomination : this.currentCompany.Name + " " + this.currentCompany.Surname;
    this.oldSystemSurvey.Email = this.currentUser.Email;

    this.userService.sendSurveyViaEmail(this.oldSystemSurvey).then(() => {
      this.goToOldSystem();
    }).catch(err => {
      DialogService.Error(err.message);
    });
  }

  /**
   * Effettua un controllo sulle proprietà dell'oggetto oldSystemSurvey per disabilitare/abilitare il pulsante di conferma del sondaggio
   */
  checkDisabledConfirmSurvey() {
    if ((this.oldSystemSurvey.FunctionalIssue == null || this.oldSystemSurvey.FunctionalIssue == false)
      && (this.oldSystemSurvey.GraphicIssue == null || this.oldSystemSurvey.GraphicIssue == false)
      && (this.oldSystemSurvey.TimeIssue == null || this.oldSystemSurvey.TimeIssue == false)
      && (this.oldSystemSurvey.OtherIssue == null || this.oldSystemSurvey.OtherIssue == ""))
      return true;
    else
      return false
  }

  checkReleaseNote() {
    if (localStorage.getItem("ReleaseNote20") == null) {
      Swal.fire({
        title: 'Aggiornamento Fatturazione 3.0.0.0',
        text: 'Cliccare su "Conferma" per scaricare le note di rilascio, premere CTRL + F5 per aggiornare la pagina.',
        icon: 'warning',
        showConfirmButton: true,
        showDenyButton: true,
        denyButtonText: this.translate.instant("GENERIC_LABEL.ABORT"),
        confirmButtonText: this.translate.instant("GENERIC_LABEL.CONFIRM")
      }).then(res => {
        if (res.isConfirmed) {
          window.open("https://servicedesk-vsp.namirial.com/hc/it/articles/39305211486609-Note-di-Rilascio-3-0-0-0", '_blank');
        }
        localStorage.setItem("ReleaseNote20", "true");
      })
    }

  }

  //Controllo se la policy è stata letta
  checkPolicyReaded() {

    if (this.authService.getCurrentUser().PolicyReaded != true) {

      this.dialogPolicyReadedRef = this.dialog.open(this.dialogPolicyReaded, {
        minHeight: "20%",
        minWidth: "40%",
        disableClose: true,
        hasBackdrop: true,
        autoFocus: false,
      });
    }    
  }
  

  //Controllo se la survey è stata letta
  checkSurveyReaded() {
    if (true) //NAMIRIALPAY
    { 
      if (this.authService.getCurrentUser().SurveyDone == null) {

          this.dialogSurveyDoneRef = this.dialog.open(this.dialogSurveyDone, {
            minHeight: "10%",
            minWidth: "20%",
            disableClose: true,
            hasBackdrop: true,
            autoFocus: false,
          });
        }
    }
  }

  confirmSurveyDone() {    
    if (this.dontShowNamirialPayAgain) {    
      this.userService.setSurveyDone(this.authService.getCurrentUser().ID).then((res) => {        
        DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
        this.authService.setCurrentToken(res.Value);
      }).catch(error => {
        DialogService.Error(error.message);
      });
    }
    
    if (this.dialogSurveyDoneRef)
      this.dialogSurveyDoneRef.close();

    // VECCHIO SURVEY
    // this.userService.setSurveyDone(this.authService.getCurrentUser().ID).then((res) => {
    //   if (this.dialogSurveyDoneRef)
    //     this.dialogSurveyDoneRef.close();

    //   DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
    //   this.authService.setCurrentToken(res.Value);
    // }).catch(error => {
    //   DialogService.Error(error.message);
    // });

  }

  //Parte la chiamata che aggiorna il campo PolicyReaded per l'utente connesso
  confirmPolicyReaded() {
    this.userService.setPolicyToReaded(this.authService.getCurrentUser().ID).then((res) => {
      DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
      this.authService.setCurrentToken(res.Value);
      if (this.currentCompany.PreRegisteredCompany == true && this.currentCompany.AuthSPID == false) {        
        // Questa chiamata viene fatta solo per i clienti GYB 
        // quindi è da rivedere se e quando verrà gestita la cosa
        DialogService.Confirm(this.translate.instant("GENERIC_LABEL.SPID_CONFIRM"), () => {
          if (this.currentCompany.AuthSPID === false) {
            this.spidService.getSPIDUrlLogin();
          } else {
            this.portaleFEService.PortaleFEAuth();
          }
        }, true);
      }
    }).catch(error => {
      DialogService.Error(error.message);
    });
  }

  //#region GESTIONE NOTIFICHE

  async initializeSocketNotificationConnection() {
    this.startConnection();
    this.NewConnection();
    this.NotificationDataUpdated();
    this.loadUnreadNotification(false);

    this.notificationReadSubscription = this.eventHandlerService.subscribe(
      'NotificationReadEvent',
      (response) => {
        this.notificationCount = (this.notificationCount > 0 ? this.notificationCount - 1 : 0);
      }
    );
  }

  /**
   * Costruisce una connessione con l'hub che gestisce il web socket per l'invio delle notifiche in tempo reale,
   * la avvia e connette il client all'hub.*
   */
  public startConnection = async () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.apiUrl + '/NotificationHub', {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        timeout: 300000
      })
      .build();

    this.hubConnection
      .start()
      .then(() => {
        this.onConnection();
      })
      .catch(err => console.log('Error while starting connection: ' + err))
  }

  /**
   * Una volta aperta la connessione invoca il metodo "Connect" dell'hub per registrare la connessione dell'utente loggato
   */
  public onConnection = () => {
    this.hubConnection.invoke('Connect', this.currentUser.ID, (data) => {
    });
  }

  /**
   * Metodo invocato dal server quando il client si connette.
   * Nel data di default troviamo l'id della connessione all'hub.
   */
  public NewConnection = () => {
    this.hubConnection.on('MyConnectionId', (data) => {
    });
  }

  /**
   * Metodo chiamato quando l'hub notifica all'utente loggato la ricezione di una nuova notifica.
   * Aumenta il contatore di 1, mostra il toast con il titolo della notifica ricevuta e emette l'evento "NotificationUpdateEvent".
   */
  public NotificationDataUpdated = () => {
    this.hubConnection.on('NotificationDataUpdate', (notificationMessage) => {
      this.notificationCount = this.notificationCount > 0 ? (this.notificationCount + 1) : 1;
      DialogService.ShowNewNotification(notificationMessage);
      this.eventHandlerService.broadcast({ name: 'NotificationUpdateEvent', content: '' });
    });
  }

  /**
   * Carica le notifiche non lette dell'utente loggato.
   * Se viene passato il parametro a true apre la tendina delle notifiche.
   * @param openDropdown
   */
  async loadUnreadNotification(openDropdown: boolean = true) {
    this.notificationList = new Array<NotificationDetailDTO>();
    await this.notificationService.getNotifications(true)
      .then(res => {
        this.notificationCount = (res && res.length > 0 ? res.length : 0);
        this.notificationList = res ? res : new Array<NotificationDetailDTO>();
        this.notificationToShow = this.notificationList.filter(n => (n.NotificationNotificationType == NotificationTypeEnum.EMERGENCY || n.NotificationNotificationType == NotificationTypeEnum.MAINTENANCE || n.NotificationNotificationType == NotificationTypeEnum.RELEASE) && (n.NotificationExpireDate == null || new Date(n.NotificationExpireDate).getTime() > new Date().getTime()))
        if (this.notificationToShow != null && this.notificationToShow.length > 0) {
          if (this.notificationToShow.length > 1)
            this.notificationToShow.sort((a, b) => { return (new Date(a.SendDate).getTime()) - (new Date(b.SendDate).getTime()) });
          let notification = this.notificationToShow.pop();
          this.readNotification(notification);
        }
        if (openDropdown)
          this.trigger.openMenu();
      })
      .catch((err) => { DialogService.Error(err.message); });
  }

  /**
   * Se viene aperta una notifica non letta salva data/ora di lettura e apre il dialog per la visualizzazione della stessa.
   * @param notificationDetail
   */
  readNotification(notificationDetail: NotificationDetailDTO) {
    if (!notificationDetail.ReadDate) {
      this.notificationService.markAsRead(notificationDetail.ID)
        .then((res) => {
          notificationDetail.ReadDate = res;
          this.eventHandlerService.broadcast({ name: 'NotificationReadEvent', content: { ReadDate: res, ID: notificationDetail.ID } });
        })
        .catch((err) => { DialogService.Error(err.message); });
    }
    this.selectedNotification = notificationDetail;
    this.dialogViewNotificationRef = this.dialog.open(this.dialogViewNotification, {
      disableClose: false,
      hasBackdrop: true,
      autoFocus: false,
      width: '40%',
    });
  }
  getAccessibilityLink() {
      let accessibilitylink = "";  
      let language = GlobalService.getSelectedLanguage() == "it" ? "it" : "en";
  
      if (language == 'it')
      {
        accessibilitylink = `https://www.namirial.com/${language}/dichiarazione-accessibilita/`;
      }
      else
      {
        accessibilitylink = `https://www.namirial.com/${language}/accessibility-statement/`;
      }
      
      
  
      window.open(accessibilitylink, '_blank');
  }
  /**
   * Redirect alla lista delle notifiche ricevute dall'utente.
   */
  goToNotificationList() {
    this.router.navigate(['/list-notification'], { relativeTo: this.activatedRoute });
  }
  //#endregion

  openFEUrl() {
    DialogService.Confirm(this.translate.instant("GENERIC_LABEL.GO_TO_FE"), () => {
      this.portaleFEService.PortaleFEAuth();
    }, true);
  }

  openShopUrl(renewal: boolean = false) {
    DialogService.Confirm(this.translate.instant("GENERIC_LABEL.GO_TO_SHOP"), () => {
      this.shopService.GoToShop(renewal);
    }, true);
  }

  openDeskUrl(renewal: boolean = false) {
     DialogService.Confirm("URL DESK PROFESSIONISTI", () => {
       
     }, true);
    // DialogService.Confirm(this.translate.instant("GENERIC_LABEL.GO_TO_SHOP"), () => {
    //   this.shopService.GoToShop(renewal);
    // }, true);
  }

  licenseExpiredDialog() {
    
    this.globalService.isLicenseInsideExpired = false;        
    
    if (this.globalService.currentManagedCompany == null && this.currentCompany != null && ((this.currentCompany.FK_CommercialProductInUse == 1 || this.currentCompany.FK_CommercialProductInUse == 4) && this.currentCompany.IsCommercialProductInUseExpired != null)) {
            
      // Se Inside imposta flag licenza scaduta
      // FP-670
      //this.globalService.isLicenseInsideExpired = (this.currentCompany.AuthSPID == null);
      this.globalService.isLicenseInsideExpired = (this.currentCompany.CompanyType == CompanyTypeEnum.INSIDE);


      let todayAdd10 = moment().add(10, 'd');
      let licenseExpiringMessage = moment(this.currentCompany.IsCommercialProductInUseExpired).isBefore(moment()) ? this.translate.instant("GENERIC_LABEL.LICENSE_EXPIRED_ON") : this.translate.instant("GENERIC_LABEL.LICENSE_WILL_EXPIRE");
      let info: string = licenseExpiringMessage;
      
      // Se SHOP GoToShop
      // Se Inside Messaggio di avviso
      // Se Desk GotoDesk
      
      // In base al tipo di rinnovo (automatico o manuale) si apre il dialog con il messaggio corretto 
      if (this.currentCompany.ChargeBeeStatus == 0 || this.currentCompany.ChargeBeeStatus == 3) {
                        
        info = licenseExpiringMessage + moment(this.currentCompany.IsCommercialProductInUseExpired).format('DD/MM/YYYY') + ". "
        
        if (this.currentCompany.CompanyType == CompanyTypeEnum.INSIDE ) 
        {
          info += this.translate.instant("GENERIC_LABEL.LICENSE_RENEW_INSIDE");
        }
        else
        {
          info += this.translate.instant("GENERIC_LABEL.LICENSE_RENEW");        
        }

        if (this.currentCompany.CompanyType == CompanyTypeEnum.INSIDE )  
        {
          DialogService.Warning(info);
        }
        else
        {
          DialogService.Confirm(info, () => {
            if (this.currentCompany.CompanyType == CompanyTypeEnum.SHOP )  
              this.shopService.GoToShop(true);
            else
              this.openDeskUrl(true);

          }, true, this.translate.instant("GENERIC_LABEL.ATTENTION"), null, false, this.translate.instant("GENERIC_LABEL.CONFIRM"));
        }
      }

      if (this.currentCompany.ChargeBeeStatus == 1 || this.currentCompany.ChargeBeeStatus == 2) {
        if (this.currentCompany.ChargeBeeStatus == 1 ) 
          info = licenseExpiringMessage + moment(this.currentCompany.IsCommercialProductInUseExpired).format('DD/MM/YYYY') + ". " + this.translate.instant("GENERIC_LABEL.LICENSE_RENEW_CHARGEBEE");        
        else
          info = licenseExpiringMessage + moment(this.currentCompany.IsCommercialProductInUseExpired).format('DD/MM/YYYY') + ". " + this.translate.instant("GENERIC_LABEL.LICENSE_RENEW_CHARGEBEE_DISABLE");        
        
        DialogService.Confirm(info, () => {                    
          window.open("https://suite.namirial.app/#/licenses", '_blank');
        }, true, this.translate.instant("GENERIC_LABEL.ATTENTION"), null, false, this.translate.instant("GENERIC_LABEL.CONFIRM"));
      }

    }
  }

  fromShopQueueDialog() {
      if (this.globalService.authSpidOk==false &&  this.globalService.currentManagedCompany == null && this.currentCompany != null && this.currentCompany.FromShopQueue == true && this.currentCompany.AuthFE == false) {
        DialogService.Confirm(this.translate.instant( this.currentCompany.AuthSPID==false? "DIALOGS.SHOP_SDI_AUTHENTICATION_MISSING":"GENERIC_LABEL.GO_TO_FE"), () => {
          if (this.currentCompany.AuthSPID === false) {
            this.spidService.getSPIDUrlLogin();
          } else {
            this.portaleFEService.PortaleFEAuth();
          }
        }, true);
      return;
    }
  }

  fromNamirialPayOnboardingDialog() {            
    // if (this.NamirialPayOnboarding()) {
    //   DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_ONBOARDING"), () => {      
    //     DialogService.Info("Contact customer service to activate NamirialPay service");
    //   }, true);
    //   return;
    // }

    if (this.NamirialPayOnboarding()) {     
      DialogService.Info(this.translate.instant("DIALOGS.NAMIRIAL_PAY_ONBOARDING"));      
      return;
    }
    
  }

  NamirialPayOnboarding(): boolean {
    if (this.currentCompany == null || this.globalService.companyDashboardStaticObject == null) {
      return false;
    }
    let numberPackage = this.globalService.companyDashboardStaticObject?.ChildDetailProducts?.filter(p => p.ProductType === 1).length || 0;
    return (this.currentCompany.isNamirialPayActive <= 0 && numberPackage > 0);
  }



  remainingInvoicesFinished() {
    
     // Il Check deve essere effettuato in base a queste condizioni:
     // this.currentCompany.CompanyType == CompanyTypeEnum.SHOP o
     // this.currentCompany.CompanyType == CompanyTypeEnum.DESK && this.currentCompany.PackageQuantity > -1
     // Se è uno SHOP o è un DESK con un pacchetto di fatture (200)
     // Avendo in comune il packageQuantity > -1 possiamo utilizzare solo questo parametro
     if (this.globalService.currentManagedCompany == null && this.currentCompany != null && this.currentCompany.AuthFE == true && this.currentCompany.PackageQuantity > -1 &&  this.currentCompany.RemainingInvoices <= 5) {
        DialogService.Warning("Le fatture a tua disposizione stanno per terminare. Nessun problema, puoi acquistare un pacchetto aggiuntivo di fatture facendo click sul carrello presente nella barra inferiore del Contatore Fatture");                
     }
          
  }


  remainingInvoicesInsideFinished() {
        
    // INSIDE AVVISA SE RESIDUO <= 10%  E PackageQuanrity > 0  (potrebbe essere demo o non aver letto dal manager)            
    if (this.globalService.currentManagedCompany == null && this.currentCompany != null && this.currentCompany.AuthFE == null && this.currentCompany.PackageQuantity != 0) {

      this.userService.GetInvoiceInfoPackage(this.currentCompany.ID).then((res) => {                            
          this.currentCompany.PackageQuantity =  res.PackageQuantity;
          this.currentCompany.ActiveInvoiceCounter = res.ActiveInvoiceCounter;
          this.currentCompany.PassiveInvoiceCounter = res.PassiveInvoiceCounter;     
          
          this.globalService.companyDashboardStaticObject.PackageQuantity = res.PackageQuantity;
          this.globalService.companyDashboardStaticObject.ActiveInvoiceCounter = res.ActiveInvoiceCounter;
          this.globalService.companyDashboardStaticObject.PassiveInvoiceCounter = res.PassiveInvoiceCounter;
          this.globalService.companyDashboardStaticObject.RemainingInvoices = res.PackageQuantity - (res.ActiveInvoiceCounter + res.PassiveInvoiceCounter);

          // INSIDE AVVISA SE RESIDUO <= 10%  E PackageQuanrity > 0  (potrebbe essere demo o non aver letto dal manager)                      
          // I clienti del pacchettone hanno PackageQuantity = -1
          if (this.currentCompany.PackageQuantity>0)
          {
            this.nRemainingInvoicesInside = 100 - (((this.currentCompany.ActiveInvoiceCounter + this.currentCompany.PassiveInvoiceCounter) / this.currentCompany.PackageQuantity) * 100);                  
          }
          else
          {
            this.nRemainingInvoicesInside = 50;
          }
          
          // Server per Battery DashBoard
          this.globalService.availableInvoicesPercentage = this.nRemainingInvoicesInside;  
          if (this.nRemainingInvoicesInside <= 10)
            {
              DialogService.Warning("Le fatture a tua disposizione stanno per terminare. Ti invitiamo a contattare l'ufficio commerciale.");        
              this.userService.sendCommercialEmail(this.currentCompany.ID);
            }            
          }                 
        ).catch((err) => {      
        })
      }
    
 }

  
  closeVisualizationModal() {
    this.dialogViewNotificationRef.close();
    if (this.notificationToShow.length > 0) {
      let notification = this.notificationToShow.pop();
      this.readNotification(notification);
    }
  }

  styleBattery(): any {
    let backgroundColor: string = "";
    if (this.globalService.availableInvoicesPercentage < 20) {
      backgroundColor = "red";
    } else if (this.globalService.availableInvoicesPercentage < 50) {
      backgroundColor = "#e2e22d";
    } else {
      backgroundColor = "#0ea501";
    }
    return { height: this.globalService.availableInvoicesPercentage + '%', "background-color": backgroundColor };
  }

  checkMyNamirialLogin(): void {
            

    this.displayiFrame = (this.authService.tokenMyNamirialAvailable() && this.authService.tokenAvailable());    

    if  (this.displayiFrame) {
      this.iFrameURLCheck = this.sanitizer.bypassSecurityTrustResourceUrl(environment.apiMyNamirialUrl);    
      
      window.addEventListener("message", (e) => {
                

        if (e.origin !== environment.apiMyNamirialUrl) {
          return
        }
                

        if (e.data == "logout")
        {        
          this.logout()             
        }                  
      })
    }

  }
  
}
